<template>
  <div class="loginDynamicPassPage">
    <job-header-simple header_title="更换手机号码"></job-header-simple>
    <van-field v-model="tel" label="原手机号" disabled />
    <van-field
      v-model="pass"
      type="password"
      clearable
      placeholder="请填写登录密码"
      :border="input_border"
    />
    <van-field
      v-model="newTel"
      clearable
      placeholder="请填写新的手机号"
      :border="input_border"
    />
    <van-field
      v-model="code"
      clearable
      placeholder="请填写动态码"
      :border="input_border"
    >
      <template slot="button">
        <van-count-down
          ref="countDown"
          :auto-start="false"
          @finish="countFinished"
          :time="time"
          format="ss"
          v-show="isOn"
          class="i-text"
        />
        <span @click="handleCode" class="i-text" v-show="!isOn"
          >发送验证码</span
        >
      </template>
    </van-field>
    <van-button
      type="info"
      size="large"
      class="btn"
      @click="onClickButtonSubmit"
      :loading="loading"
      loading-text="提交中..."
      >提 交</van-button
    >
  </div>
</template>
<script>
import { Button, Field, Toast, Icon, CountDown, Notify } from "vant";
import jobHeaderSimple from "@/components/header/header.vue";
import api from "@/api/list";
import { rsaEncrypt } from "@/utils/rsa";
export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [CountDown.name]: CountDown,
    jobHeaderSimple,
    [Notify.name]: Notify,
  },
  data() {
    return {
      input_border: false,
      tel: "",
      id: null,
      pass: "",
      newTel: "",
      code: "",
      time: 60 * 1000, //5秒
      isOn: false,
      token: null,
      loading: false,
    };
  },
  created() {
    this.id = this.$store.getters.userInfo.id;
    this.tel = this.$store.getters.userInfo.mobile;
  },
  methods: {
    onClickButtonSubmit() {
      if (this.pass == "") {
        this.$toast("登录密码不能为空");
        return false;
      }
      if (this.newTel == "") {
        this.$toast("新的手机号码不能为空");
        return false;
      }
      if (this.code == "") {
        this.$toast("验证码不能为空");
        return false;
      }
      api
        .mobileValidate(
          {},
          {
            method: "post",
            subUrl: this.newTel,
          }
        )
        .then((res) => {
          if (res.data.status == "200") {
            if (res.data.data) {
              this.$toast("手机号码已存在，请更换其他手机号码");
              return false;
            } else {
              this.loading = true;
              let parm = {
                mobile: this.tel,
                password: this.pass,
                newMobile: this.newTel,
                code: this.code,
                token: this.token,
              };
              let temp = JSON.parse(JSON.stringify(parm));
              // 加密数据
              temp.password = encodeURIComponent(rsaEncrypt(temp.password));
              api
                .updateMobile(temp, { method: "post" })
                .then((res) => {
                  if (res.data.status == "200") {
                    this.isOn = false;
                    this.$refs.countDown.reset();
                    this.loading = false;
                    this.$toast({
                      duration: 1500, // 持续展示 toast
                      forbidClick: true,
                      message: "操作成功",
                      onClose: () => this.$router.go(-1),
                    });
                  } else {
                    this.$toast(res.data.message);
                    this.loading = false;
                  }
                })
                .catch((error) => {
                  this.$toast(error.response.data.message);
                  this.loading = false;
                });
            }
          } else {
            this.$toast(res.data.message);
          }
        })
        .catch((error) => {
          this.$toast(error.response.data.message);
          this.loading = false;
        });
    },
    handleCode() {
      if (this.newTel == "") {
        this.$toast("手机号码不能为空");
        return false;
      }
      if (this.newTel === this.tel) {
        this.$toast("新手机号码与旧手机号一致");
        return false;
      }
      api
        .mobileValidate(
          {},
          {
            method: "post",
            subUrl: this.newTel,
          }
        )
        .then((res) => {
          if (res.data.status == "200") {
            if (res.data.data) {
              this.$toast("手机号码已存在，请更换其他手机号码");
              return false;
            } else {
              api
                .sendSms({ mobile: this.newTel })
                .then((res) => {
                  if (res.data.status == "200") {
                    this.token = res.data.data;
                    this.isOn = true;
                    this.$refs.countDown.start();
                  } else {
                    this.$toast(res.data.message);
                  }
                })
                .catch((error) => {
                  this.$toast(error.response.data.message);
                  this.loading = false;
                });
            }
          } else {
            this.$toast(res.data.message);
          }
        })
        .catch((error) => {
          this.$toast(error.response.data.message);
          this.loading = false;
        });
    },
    countFinished() {
      this.isOn = false;
      this.$refs.countDown.reset();
    },
  },
  mounted: function () {
    document.getElementsByTagName("body")[0].className = "bg_f";
  },
  beforeDestroy: function () {
    document.body.removeAttribute("class", "bg_f");
  },
};
</script>

<style lang="less" scoped>
.loginDynamicPassPage {
  display: block;
  padding: 44px;

  .links {
    position: fixed;
    left: 0;
    bottom: 90px;
    width: 100%;
    text-align: center;
    a {
      font-size: 13px;
      color: @blue;
    }
  }

  .btn {
    margin-top: 60px;
  }

  .i-text {
    color: @blue;
    font-size: 12px;
  }

  /deep/ .van-field {
    .van-field__label {
      width: 1.8rem;
      color: #999;
    }

    .van-field__control:disabled {
      color: #6c7ef3;
      -webkit-text-fill-color: #6c7ef3;
    }
  }
}
</style>
<style lang="less">
.loginDynamicPassPage {
  .van-cell {
    margin-bottom: 10px;
    border-radius: 6px;
    padding: 11px 25px;
    background: #f3f3f3;
  }
}
</style>



